import { Grid, Typography } from '@mui/material';
import { Form, Formik } from 'formik';
import * as Yup from 'yup';
import { useDispatch } from 'react-redux';
import { useSnackbar } from 'notistack';
import { useState } from 'react';
import { CommonLayout } from '../../commonComponents';
import { MFSubmitButton } from '../../../lib/formik';
import { subbrokerReportDownload } from '../../MyProfile/actions';
import { reportDownload } from '../report-utils';
import FinancialYearSelect from './FinancialYearSelect';

interface Values {
    financialYear: string;
}

const validationSchema = Yup.object().shape({
    financialYear: Yup.string().required('Please select a financial year'),
});

const initialValues: Values = {
    financialYear: '',
};

export default function SubbrokerReports(): JSX.Element {
    const dispatch = useDispatch();
    const { enqueueSnackbar } = useSnackbar();
    const [isDownloading, setIsDownloading] = useState<boolean>(false);

    const handleSubmit = async ({ financialYear }: Values) => {
        try {
            setIsDownloading(true);
            const response = await (dispatch(subbrokerReportDownload({ isPDF: false, financialYear })) as unknown as Promise<any>);
            if (response?.type) {
                enqueueSnackbar('File downloaded successfully.', {
                    variant: 'success',
                    autoHideDuration: 2000,
                });
                reportDownload(response as unknown as Blob, `SubbrokerSelfDeclarationReport_${financialYear}`);
            } else {
                enqueueSnackbar('File download failed!', {
                    variant: 'error',
                    autoHideDuration: 2000,
                });
            }
        } catch (error) {
            console.error('Error:', error);
        } finally {
            setIsDownloading(false);
        }
    };

    return (
        <CommonLayout>
            <>
                <Typography
                    variant='h1'
                    sx={{
                        alignSelf: { xs: 'center' },
                        mb: 3
                    }}
                >
                    Subbroker Self Declaration Report
                </Typography>

                <Formik
                    validationSchema={validationSchema}
                    initialValues={initialValues}
                    onSubmit={handleSubmit}
                    enableReinitialize
                >
                    {() => (
                        <Form>
                            <Grid
                                container
                                rowSpacing={3}
                                sx={(theme) => ({
                                    mt: 3,
                                    border: `1px solid ${theme.palette.stroke.main}`,
                                    borderRadius: '10px',
                                    p: 3,
                                })}
                            >
                                <Grid item container columnSpacing={3}>
                                    {/* Financial Year Dropdown */}
                                    <Grid item xs={12} md={6}>
                                        <FinancialYearSelect
                                            name="financialYear"
                                            label="Select Financial Year *"
                                            minYear={2025}
                                            disabled={isDownloading}
                                        />
                                    </Grid>

                                    {/* Download Button */}
                                    <Grid item xs={12} md={6}>
                                        <MFSubmitButton
                                            label="Download Report"
                                            loadingEnable={isDownloading}
                                        />
                                    </Grid>
                                </Grid>
                            </Grid>
                        </Form>
                    )}
                </Formik>
            </>
        </CommonLayout>
    );
}
